import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Demo from './pages/Demo';
import Login from './pages/Login';
import Documents from './pages/Documents';
import Chat from './pages/ChatWithRAG';
import './index.css';
import { getCurrentSession, signOutApiUser } from './services/apiAuth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const session = getCurrentSession();
    if (session) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    const session = getCurrentSession();
    if (session) {
      setIsAuthenticated(true);
    }
  };

  const handleLogout = () => {
    signOutApiUser();
    setIsAuthenticated(false);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/" replace />}
          />
          <Route
            path="/"
            element={isAuthenticated ? <Demo onLogout={handleLogout} /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/documents"
            element={isAuthenticated ? <Documents onLogout={handleLogout} /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/chat"
            element={isAuthenticated ? <Chat /> : <Navigate to="/login" replace />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
